module.exports = __webpack_public_path__ + "static/media/orderDetailsLinkIcon.304b4036.svg";